import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import { AuthenticationDAO } from "@/API/DAO/AuthenticationDAO";
import swal from 'sweetalert2';
let NewEmailConfirmation = class NewEmailConfirmation extends Vue {
    constructor() {
        super();
        this.message = '';
        this.confirmationSuccessful = false;
        this.processingConfirmation = false;
        this.resentConfirmationCodeSuccessful = false;
    }
    signIn() {
        // @ts-ignore
        window.location = process.env.VUE_APP_CONFIGIO_URL + "/login?ReturnURL=%2FShoppingCart.aspx";
    }
    getError(fieldName) {
        return this.$validator.errors.first(fieldName);
    }
    get emailValidation() {
        return {
            email: true,
            required: true,
            min: 2
        };
    }
    async resendConfirmationCode() {
        this.processingConfirmation = true;
        let confirmResponse = await AuthenticationDAO.resendAccountConfirmation(this.emailAddress);
        if (confirmResponse.successful === true) {
            await swal.fire({
                title: `Confirmation Sent`,
                text: `We have resent the confirmation email to ` + this.emailAddress,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
        }
        else {
            await swal.fire({
                title: `Resend Confirmation Code`,
                text: confirmResponse.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
        }
        this.processingConfirmation = false;
        this.signIn();
    }
    async mounted() {
        this.confirmationSuccessful = true;
        this.resentConfirmationCodeSuccessful = false;
        if (this.$route.query.email === null || this.$route.query.email === undefined) {
            this.emailAddress = '';
            this.confirmationSuccessful = false;
        }
        else {
            this.emailAddress = this.$route.query.email.toString();
            this.message = "Not all required values are available, please click the resend the bottom";
        }
        if (this.$route.query.confirmation === null || this.$route.query.confirmation === undefined) {
            this.confirmationCode = '';
            this.confirmationSuccessful = false;
        }
        else {
            this.confirmationCode = this.$route.query.confirmation.toString();
            this.message = "Not all required values are available, please click the resend the bottom";
        }
        if (this.confirmationSuccessful === true) {
            try {
                this.processingConfirmation = true;
                console.log('Calling Confirm Account: ' + this.confirmationCode + '-' + this.emailAddress);
                let confirmResponse = await AuthenticationDAO.confirmAccount(this.confirmationCode, this.emailAddress);
                this.confirmationSuccessful = confirmResponse.successful;
                if (confirmResponse.successful === true) {
                    this.message = 'Your account has been confirmed';
                    this.confirmationSuccessful = true;
                }
                else {
                    this.message = confirmResponse.message;
                    this.confirmationSuccessful = false;
                }
            }
            catch (error) {
                this.message = "Failed to confirm your email, please click resend below...";
                this.confirmationSuccessful = false;
            }
        }
        this.processingConfirmation = false;
    }
};
NewEmailConfirmation = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
        }
    })
], NewEmailConfirmation);
export default NewEmailConfirmation;
